import { Environment } from 'fines-portal/core/data-access/environment';

declare const APP_VERSION: string;

/**
 * production environment
 */
export const environment: Environment = {
    appName: 'fines-portal',
    environmentName: 'prod',
    assetConfigPath: '/assets/fines-portal.json',
    version: APP_VERSION,
    apiBasePath: 'https://deveiligstestad.be/api',
    storageKey: 'fines-portal',
};
